import { EUFY_HOME_APPLICATION_NAME, EUFY_LIFT_APPLICATION_NAME, getCookie, getNativeInfo, isAndroid, isInApp, normalizeAppName, openBrowser, openWebview } from '@docs/common'
import * as cheerio from 'cheerio';
import { CONTENT_TYPE, DEFAULT_APP_NAME, DOMAINS } from './constant'

import { snakeCase } from 'lodash'
import qs from 'qs'

const PROPERTIES = [
  'discount',
  'type',
  'code',
  'startAt',
  // 'validAt',
]

/**
 * 通过 YouTube 的视频详情页面 url 参数获取视频id
 * @param {number} url 例如：https://www.youtube.com/watch?v=7H7cTSml5zk
 * @returns {boolean}
 */
export function youtubeId(url: string) {
  const res = (url || '').match(
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i
  )
  return (res && res[1]) || ''
}

export const getInfoFromTopicHtml = (html = '') => {
  const result = { images: [], digest: '' } as { images: { [name: string]: string }[]; digest: string }
  if (!html) return result
  const $ = cheerio.load(html)
  $('img').each((i, elem) => {
    if (elem.attribs?.class?.includes('emoji')) {
      // todo
    } else {
      result.images.push(elem.attribs)
    }
  })
  result.digest = $('p').text()
  return result
}

export const JOSNParse = <T>(str: string) => {
  try {
    return JSON.parse(str) as T
  } catch (error) {
    return undefined
  }
}
/** 是否为服务端 */
export function isServerSide(): boolean {
  return typeof window === 'undefined'
}
export function getClientEnv(key: string): string | undefined {
  if (isServerSide()) {
    return process.env[key]
  }
  const envs = window.sessionStorage.getItem('ENVS')
  if (envs) {
    const parsed = JSON.parse(envs)
    return parsed[key]
  }
}

export const isHttpOrHttps = (str: string) => str.startsWith('https://') || str.startsWith('http://')

export const isQa = () => getClientEnv('REACT_APP_DEPLOY_ENV') === 'qa'

export const getDeployRegion = () => (getClientEnv('REACT_APP_DEPLOY_REGION') ?? 'US').toUpperCase()

export const isDev = () => process.env.NODE_ENV === 'development'

export const isEu = async () => {
  const appinfo = await getNativeInfo()
  if (appinfo.domain) {
    return appinfo.domain.includes('-eu')
  } else if (window.location.href.includes('-eu')) {
    return true
  }
  return false
}

export const getCommunityDomain = () => {
  if (isDev()) return `/community`
  if (isQa()) return DOMAINS.discourse.qa

  return DOMAINS.discourse.pr
}

export const getMallDomain = async () => {
  if (isDev()) return '/mall'
  if (isQa()) return DOMAINS.mall.qa
  if (await isEu()) return DOMAINS.mall.eu

  return DOMAINS.mall.pr
}

export const getTutorialDomain = async () => {
  if (isDev()) return DOMAINS.tutorial.qa
  if (isQa()) return DOMAINS.tutorial.qa
  return DOMAINS.tutorial.pr
}

export const getAppDomain = async () => {
  const DEPLOY_REGION = getDeployRegion()
  if (isQa()) return DOMAINS.app[DEPLOY_REGION].qa
  return DOMAINS.app[DEPLOY_REGION].pr
}

export const getCmsDomain = async () => {
  const DEPLOY_REGION = getDeployRegion()
  console.log('qa', DEPLOY_REGION,isDev(),isQa())
  if (isDev()) return '/cms'
  if (isQa()) return DOMAINS.cms[DEPLOY_REGION].qa
  
  return DOMAINS.cms[DEPLOY_REGION].pr
}

export const getContentType = async () => {
  const params = qs.parse(window.location.search.substr(1))
  let appName = typeof params.app === 'string' ? params.app : DEFAULT_APP_NAME

  // 如果url带了appName参数，优先使用
  if (appName) {
    return CONTENT_TYPE[snakeCase(appName)] || CONTENT_TYPE['eufy_security']
  }

  if (await isInApp()) {
    const info = await getNativeInfo()
    appName = info.appName || appName
  }
  return CONTENT_TYPE[snakeCase(appName)] || CONTENT_TYPE['eufy_security']
}

export const getLanguae = () => {
  const { lang } = qs.parse(window.location.search.substr(1))
  if (typeof lang === 'string') {
    return lang
  }
  let language = navigator.language || 'en-US'
  // 系统原因 部分手机返回小写
  if (language.startsWith('en-')) {
    language = language.replace(/en-(.*)/, (match, p1) => `en-${p1.toUpperCase()}`)
  }
  return language
}

// 获取search参数的country属性
export const getSearchCountry = () => {
  const { country } = qs.parse(window.location.search.substr(1))
  if (typeof country === 'string') {
    return country
  }
  return ''
}

// start_ai_generated
function extractHttpContent(url: string) {
  // 正则表达式匹配 http 或 https 开头的 URL
  const pattern = /(https?:\/\/.*)/i
  const match = url.match(pattern)
  return match ? match[1] : null // 返回匹配的部分或者 null（如果没有匹配）
}
// end_ai_generated

// 生成中转页链接
// 如果拼接了eufysecurity://eufy/explore/web 安卓这个路由会认为你是非法域名 app会自动finis
// 采用中转页目的是判断是否安装app
function generateRedirectUrlIos(appPage: string) {
  // 如果appPage 前面是已eufysecurity://eufy/explore/web#开头的则删除eufysecurity://eufy/explore/web#
  // start_ai_generated
  if (appPage.startsWith('eufysecurity://eufy/explore/web#')) {
    appPage = appPage.replace('eufysecurity://eufy/explore/web#', '')
  }
  // end_ai_generated
  const iosUrl = 'https://apps.apple.com/app/id1424956516?ref=footer'
  const pcUrl = 'https://apps.apple.com/app/id1424956516?ref=footer'
  const appUrl = `eufysecurity://eufy/explore/web#${encodeURIComponent(appPage)}`
  const resUrl = `https://security-mall.eufylife.com/landing/redirect/?ios=${encodeURIComponent(
    iosUrl
  )}&app=${encodeURIComponent(appUrl)}&pc=${encodeURIComponent(pcUrl)}`

  return resUrl
}

function generateRedirectUrlAndroid(appPage: string) {
  const androidUrl = 'https://play.google.com/store/apps/details?id=com.oceanwing.battery.cam'
  const resUrl = `https://security-mall.eufylife.com/landing/redirect/?and=${encodeURIComponent(
    androidUrl
  )}&app=${encodeURIComponent(appPage)}`
  return resUrl
}

const nebulaisAndroid = 'https://play.google.com/store/apps/details?id=com.zhixin.controller'
const nebulaisIos = 'https://apps.apple.com/us/app/nebula-connect-smartprojector/id1319092174'

export const triggerLink = async (url: string) => {

  let appName = getCookie('app_name')
  if(!appName){
    try {
      const nativeInfo = await getNativeInfo()
      appName = normalizeAppName(nativeInfo?.appName)
    } catch (error) {
      console.error('triggerLink error', error)
    }
  }

  // life home 调用原生桥
  if (appName === EUFY_HOME_APPLICATION_NAME || appName === EUFY_LIFT_APPLICATION_NAME) {
    openWebview(url)
    return
  }

  // 第一种情况：开头是 http 或者 https 的直接跳转
  if (isHttpOrHttps(url)) {
    openBrowser(url)
  } else {
    if (!(await isInApp())) {
      const hasHttps = url.includes('https://')
      const toAppMatch = url.match(/toApp=([^&]+)/)
      const toApp = toAppMatch ? toAppMatch[1] : null
      // 第一种情况：没有带上 https ,或者带上https 有指定标识toApp的直接拉起app
      if (!hasHttps || (hasHttps && toApp)) {
        if (toApp === 'nebula-connect') {
          const redirectAndroidUrl = isAndroid ? nebulaisAndroid : nebulaisIos
          window.location.href =  redirectAndroidUrl
          return
        }
        // 只有 eufysecurity:// schema 才走 landing/redirect 中转页（中转页使用 eufy logo），
        // 其他 schema（如 soundcore://）直接跳转拉起对应 App
        if (url.startsWith('eufysecurity://')) {
          const redirectAndroidUrl = isAndroid ? generateRedirectUrlAndroid(url) : generateRedirectUrlIos(url)
          window.location.href = redirectAndroidUrl
        } else {
          window.location.href = url
        }
        return
      }
      // 第二种情况：不需要跳转至app,截取从 https 开头的 url
      const content = extractHttpContent(url)
      window.location.href = content || url

      return
    }
    openWebview(url)
  }
}

export const getCommunityAvator = (url: string) => {
  const link = url.replace(/{size}/, '40')
  if (isHttpOrHttps(link)) {
    return link
  } else {
    const domain = getCommunityDomain()
    return `${domain}${link}`
  }
}

export function isDiscountAvailable(discount: Discount | null) {
  if (discount) {
    const now = Date.now()
    let flag = new Date(discount.startAt).getTime() < now
    if (discount.endAt) {
      flag = flag && new Date(discount.endAt).getTime() > now
    }
    return flag
  }
  return false
}

export function parseDiscount(str?: string): Discount | null {
  if (!str) return null
  try {
    const discount = JSON.parse(str)
    if (PROPERTIES.every(v => Object.prototype.hasOwnProperty.call(discount, v))) {
      return discount
    }
  } catch {
    console.error('parse discount failed.', str)
  }
  return null
}

// start_ai_generated
export function isVersionAfter(currentVersion: string, targetVersion: string): boolean {
  // 定义提取版本号数字部分的正则表达式
  const versionRegex = /(\d+)\.(\d+)\.(\d+)/

  // 提取版本号中的数字部分
  const currentMatch = currentVersion.match(versionRegex)
  const targetMatch = targetVersion.match(versionRegex)

  // 如果无法提取版本号，则返回false
  if (!currentMatch || !targetMatch) return false

  // 使用非空断言操作符，确保数组不为空
  const currentNumbers = currentMatch.slice(1).map(Number)
  const targetNumbers = targetMatch.slice(1).map(Number)

  // 逐个比较版本号中的数字
  for (let i = 0; i < Math.max(currentNumbers.length, targetNumbers.length); i++) {
    // 使用 || 0 来处理undefined的情况，即缺失的版本号部分视为0
    const currentNum = currentNumbers[i] || 0
    const targetNum = targetNumbers[i] || 0
    if (currentNum > targetNum) return true
    if (currentNum < targetNum) return false
  }

  // 如果所有数字都相等，则返回false
  return false
}

const PN_RULES: Array<{ test: RegExp; pn: string }> = [
  // SN 第 7 位区分：1 → T814X，9 → T814XS
  { test: /^T814X.1/i, pn: 'T814X' },
  { test: /^T814X.9/i, pn: 'T814XS' },
]

export function resolvePnFromSn(sn?: string): string {
  if (!sn) return ''
  const hit = PN_RULES.find(rule => rule.test.test(sn))
  return hit ? hit.pn : sn.substring(0, 5)
}
